<template>
    <div>
        <Subtitle :subtitle="leftObj.subTitle" style="height: 15%" />
        <Highcharts ref="myEchartsLeft02" :parmas="leftObj.params" style="height: 85%" />
    </div>
</template>

<script>
import Subtitle from "@/components/header/subTitle.vue";
import Highcharts from '@/components/common/highcharts';
export default {
    props: {
        leftObj: {
            typeof: Object,
        },
    },
    components: {
        Subtitle,
        Highcharts
    },
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>

</style>
  